(ns dashboard.views.analysis.synchronization.config)

(def app-db-key :view/structured-analysis-sync-modal)
